import { Component, Input, OnInit, AfterViewInit, Injector } from '@angular/core';
import { first, take } from 'rxjs/operators';
import { DrupalLangClass } from '../../../../common-page-components/classes/drupal-lang-class';
import {
  AthleteGeneralInfoItem,
  RecordItem,
  ViewDataService,
  WaHelperService,
  ViewDataConfigStruct
} from 'world-archery-lib';
import {
  RecordHistoryItem,
  RecordHistoryListLocator,
  RecordHistoryListVD
} from 'world-archery-lib';

@Component({
  selector: '[app-world-records-item]',
  templateUrl: './world-records-item.component.html',
  styleUrls: ['./world-records-item.component.scss'],
})
export class WorldRecordsItemComponent extends DrupalLangClass implements AfterViewInit {
  @Input()
  Ranking: RecordItem = {} as any;
  showDetails = false;
  recordsHistory: RecordHistoryItem;

  dataToShow: Array<{
    athlete: Array<{
      FName: string;
      GName: string;
      NOC: string;
      Id: number;
      WNameOrd: boolean;
    }>;
    event: {
      name: string;
      country: string;
      NOC: string;
      date: Date;
      Id: number;
    };
    points: number;
    xs: number;
    teamnoc: string;
  }> = [];
  constructor(
    public helper: WaHelperService,
    protected views: ViewDataService,
    injector: Injector,
  ) {
    super(injector);

  }

  ngAfterViewInit() {
    const locator: RecordHistoryListLocator = new RecordHistoryListLocator();
    locator.recordArea.value = this.Ranking.areaId;
    locator.recordLevel.value = this.Ranking.levelId;
    locator.recordType.value = this.Ranking.typeId;
    const infoItem: ViewDataConfigStruct = {
      maxAge: 1800,
      interval: 1000,
      autorefresh: false,
      expectedItems: 30
    };
    const view = this.views.get(locator);
    view.applyConfiguration(infoItem);
    view
      .getDataStream()
      .pipe(take(2))
      .subscribe(next => {
        this.recordsHistory = next;
        next.forEach(value => {
          if (value.athletes instanceof Array) {
            this.dataToShow.push({
              athlete: value.athletes.map(athe => {
                return {
                  FName: athe.fName,
                  GName: athe.gName,
                  NOC: athe.noc,
                  Id: athe.id,
                  WNameOrd: athe.wNameOrd
                };
              }),
              event: {
                name: value.competition.name,
                country: value.competition.place,
                NOC: value.competition.country,
                date: value.date,
                Id: value.competition.id
              },
              points: value.points,
              xs: value.maxPoints === value.points ? value.xs : undefined,
              teamnoc: value.noc
            });
          } else {
            this.dataToShow.push({
              athlete: [
                {
                  FName: value.athletes.fName,
                  GName: value.athletes.gName,
                  NOC: value.athletes.noc,
                  Id: value.athletes.id,
                  WNameOrd: value.athletes.wNameOrd
                }
              ],
              event: {
                name: value.competition.name,
                country: value.competition.place,
                NOC: value.competition.country,
                date: value.date,
                Id: value.competition.id
              },
              points: value.points,
              xs: value.maxPoints === value.points ? value.xs : undefined,

              teamnoc: value.noc
            });
          }
        });
      });
  }
  get recordHistory() {
    return this.dataToShow;
  }
  onClick() {
    this.showDetails = !this.showDetails;
  }
  parseRank(number: number): string {
    return number > 0
      ? '+'.concat(number.toString())
      : '-'.concat(number.toString());
  }
  getClass(number) {
    if (number === 0) {
      return 'equal';
    }
    if (number > 0) {
      return 'up';
    }
    if (number < 0) {
      return 'down';
    }
  }
  getNameCountry(country: string) {
    return this.helper.getCountryNamesInfo(country) ? this.helper.getCountryNamesInfo(country).short : '';
  }
  getStatus(status: number): string {
    switch (status) {
      case 0:
        return 'Qualified';
      case 3:
        return 'Third';
      case 4:
        return 'No-quialified';
      case 5:
        return 'Qualified-red';
    }
  }
}
